import API from "..";

export default class GHSHazardInformation {

  constructor({
    psimsid,
    description
  }) {
    this.psimsid = psimsid;
    this.description = description;
  }

  static async getFromPSIMSID(psimsId) {
    const api = await API();
    const { data } = await api.get(`/GHSHazardInformation`, { params: {psimsId} } );
    // if (data.result?.psimsId !== null) {
    //   return new GHSHazardInformation(data.result);
    // }
    return data.result;
  }
}
